// src/features/dashboard/components/ChartsSection.tsx

import ProductivityChart from './ProductivityChart';
import TimeAllocationChart from './TimeAllocationChart';

type ChartsSectionProps = {
  ManagerEmployeeCode: string;
};

const ChartsSection = ({
  ManagerEmployeeCode,
}: ChartsSectionProps) => {
  return (
    <div
      className="
        grid
        w-full
        min-w-0
        max-w-full

        grid-cols-2

        gap-4
        sm:gap-5

        items-stretch
      "
    >
      {/* ==========================================================
          LEFT
          TEAM PRODUCTIVITY COMPARISON
      ========================================================== */}

      <div
        className="
          min-w-0
          w-full
          max-w-full
          overflow-hidden

          rounded-[18px]
          sm:rounded-[22px]

          border
          border-[#D9E2EC]

          bg-white

          px-3
          py-3

          sm:px-4
          sm:py-4

          shadow-sm
        "
      >
        <div
          className="
            w-full
            min-w-0
            max-w-full
            overflow-hidden
          "
        >
          <ProductivityChart
            ManagerEmployeeCode={
              ManagerEmployeeCode
            }
          />
        </div>
      </div>

      {/* ==========================================================
          RIGHT
          SPAN TIME ALLOCATION
      ========================================================== */}

      <div
        className="
          min-w-0
          w-full
          max-w-full
          overflow-hidden

          rounded-[18px]
          sm:rounded-[22px]

          border
          border-[#D9E2EC]

          bg-white

          px-3
          py-3

          sm:px-4
          sm:py-4

          shadow-sm
        "
      >
        <div
          className="
            w-full
            min-w-0
            max-w-full
            overflow-hidden
          "
        >
          <TimeAllocationChart
            ManagerEmployeeCode={
              ManagerEmployeeCode
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ChartsSection;